import ButtonRow from 'lib/src/components/button/ButtonRow';
import LinkButton from '../../components/button/LinkButton';
import DataCheck from 'lib/src/components/common/DataCheck';
import Table from 'lib/src/components/table/Table';
import { siteNames } from 'lib/src/shared/enums/site';
import { Column } from 'lib/src/types/table';
import { isEmpty } from 'lib/src/utils/generic';
import { Challenge } from 'src/types/shared/Challenge';
import useFetchChallenges from './hooks/useFetchChallenges';
import dayjs from 'dayjs';
import useFetchChallengeGroups from '@pages/challengeGroups/hooks/useFetchChallengeGroups';
import useUsersFetch from '@pages/users/users/hooks/useUsersFetch';

const ChallengesTable = () => {
    const { challenges, isFetching, fetchError } = useFetchChallenges();
    const { challengeGroups } = useFetchChallengeGroups();
    useUsersFetch();
    const columns: Column<Challenge>[] = [
        {
            key: 1,
            heading: 'Workbooks Campaign ID',
            getValue: row => `${row.workbooksCampaignID || ''}`,
        },
        {
            key: 2,
            heading: 'Name',
            getValue: row => `${row.name}`,
            searchable: true,
        },
        {
            key: 3,
            heading: 'Challenge Group',
            getValue: row =>
                `${challengeGroups.find(group => group.id === row.challengeGroupID)?.name || ''}`,
        },
        {
            key: 4,
            heading: 'Challenge Lead',
            getValue: ({ challengeLead: user }) => {
                const userName = `${user?.firstName} ${user?.lastName}`;
                return userName;
            },
        },
        {
            key: 5,
            heading: 'Start Date',
            getValue: row => dayjs(row.startDate || undefined).format('DD/MM/YYYY'),
        },
        {
            key: 6,
            heading: 'End Date',
            getValue: row => dayjs(row.endDate).format('DD/MM/YYYY'),
        },
        {
            key: 7,
            heading: 'Site permissions',
            getValue: row => siteNames[row.site] || '',
        },
        {
            key: 8,
            heading: '',
            getValue: row => {
                const endpoint = `/challenge-groups/${row.challengeGroupID}`;
                return (
                    <>
                        <ButtonRow alignment="right">
                            <LinkButton
                                color="green"
                                icon="search"
                                href={endpoint + '/challenges/' + row.id}
                            >
                                View Challenge
                            </LinkButton>
                        </ButtonRow>
                    </>
                );
            },
        },
    ];

    return (
        <DataCheck
            dataExists={!isEmpty(challenges)}
            isFetching={isFetching}
            noDataMessage="No Challenges found"
            error={fetchError}
        >
            <Table columns={columns} rows={challenges} pageSizes={[50, 100, 250]} />
        </DataCheck>
    );
};

export default ChallengesTable;
